"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { Loading } from "./Loading";

export default function ProtectedRoute({ children }) {
  const router = useRouter();
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    const checkAuth = () => {
      const isAuthenticated = !!localStorage.getItem("authDetails");

      if (!isAuthenticated) {
        router.replace("/pricing#custom-pricing");
      } else {
        setIsCheckingAuth(false);
      }
    };

    // Delay auth check until window is defined
    if (typeof window !== "undefined") {
      checkAuth();
    }
  }, [router]);

  if (isCheckingAuth) {
    return <Loading />;
  }

  return <>{children}</>;
}
